const MetabaseComputationFrequencyEnum = {
  realtime: 'Metabase_MetabaseComputation_Field_Frequency_Realtime',
  hourly: 'Metabase_MetabaseComputation_Field_Frequency_Hourly',
  daily: 'Metabase_MetabaseComputation_Field_Frequency_Daily',
  custom: 'Metabase_MetabaseComputation_Field_Frequency_Custom',
  once: 'Metabase_MetabaseComputation_Field_Frequency_Once'
}

const MetabaseComputationFrequencySelectEnum = {
  realtime: 'Metabase_MetabaseComputation_Dialog_Field_Frequency_Realtime',
  hourly: 'Metabase_MetabaseComputation_Dialog_Field_Frequency_Hourly',
  daily: 'Metabase_MetabaseComputation_Dialog_Field_Frequency_Daily',
  once: 'Metabase_MetabaseComputation_Dialog_Field_Frequency_Once'
}

export {
  MetabaseComputationFrequencyEnum,
  MetabaseComputationFrequencySelectEnum
}



// WEBPACK FOOTER //
// ./src/modules/metabase/enum/MetabaseComputationFrequencyEnum.js